/**
 * The line vocabulary (ADR-063 §5).
 *
 * A **line** is content a campaign will not go near. Session zero writes them
 * into `SessionSettings.hardExclusions`, a player may add one during play with
 * `safety_line`, and the director removes any storylet or peak carrying one of
 * these tags before selection — a filter, never a sentence appended to a prompt.
 *
 * The tags are a closed vocabulary rather than free text for one reason: a line
 * the engine cannot match against a storylet tag is a request it cannot enforce,
 * and a safety tool that only *looks* enforced is worse than one that is absent.
 * The checklist offers exactly these; pack authors tag storylets with exactly
 * these; the two meet in the director.
 *
 * Three kinds of content are **not** here because they are not lines a player
 * chooses: gratuitous gore, animal cruelty and any sexualisation of a minor-coded
 * character are absolute ceilings no `contentTier` value can raise (ADR-063 §4),
 * enforced by the build lints and the engine's age guard. Ordinary combat and
 * death are not here either — the lethality charter is the product, and a
 * campaign that wants death off-screen narrows the `deathNarration` axis.
 *
 * Grounded in the tabletop safety-tools tradition and in Spike E's scene set,
 * whose categories are this product's own content taxonomy. Three groups: content
 * categories, phobias, and plot shapes (betrayal, execution, mass death). Founder
 * decision, 2026-09-05: **all fifteen stay**, the plot shapes included, having
 * weighed that each tag is a promise the pack must honour and that excluding a
 * plot shape removes story structure rather than content. The vocabulary is
 * therefore settled; adding to it is a protocol change and a pack re-tag.
 */
import { z } from 'zod';
export const LINE_TAGS = [
    'torture',
    'child_danger',
    'animal_harm',
    'body_horror',
    'sexual_content',
    'romance',
    'drug_use',
    'suicide_self_harm',
    'betrayal_by_ally',
    'execution',
    'mass_death',
    'drowning',
    'fire',
    'confinement',
    'insects_spiders',
];
export const LineTag = z.enum(LINE_TAGS);
export function isLineTag(value) {
    return LINE_TAGS.includes(value);
}
//# sourceMappingURL=lines.js.map